import { Component, inject } from '@angular/core';
import { MentorService } from '../../service/mentor.service';
import { DisclaimerTypes } from '../../interfaces/disclaimertypes';
@Component({
    selector: 'app-mentor',
    standalone: false,
    templateUrl: './mentor.component.html',
    styleUrl: './mentor.component.scss',
})
export class MentorComponent {
    // Injections
    mentorService = inject(MentorService);

    protected disclaimerTypes = DisclaimerTypes.PAGE_FOOTER;
}
